import React, { lazy } from 'react';
import { Route } from 'react-router-dom';
import PageRoute from '../../components/Routes/PageRoute';

const PageError = lazy(
  () => import(/* webpackChunkName: "page-error" */ './PageError')
);

const PageNotFound = lazy(
  () => import(/* webpackChunkName: "page-not-found" */ './PageNotFound')
);

const NoAccess = lazy(
  () => import(/* webpackChunkName: "no-access" */ './NoAccess')
);

const SignedOut = lazy(
  () => import(/* webpackChunkName: "signed-out" */ './SignedOut')
);

export const miscRoutes = (
  <>
    <Route
      path="/500"
      element={
        <PageRoute isProtected={false}>
          <PageError />
        </PageRoute>
      }
    />
    <Route
      path="/404"
      element={
        <PageRoute isProtected={false}>
          <PageNotFound />
        </PageRoute>
      }
    />
    <Route
      path="/no-access"
      element={
        <PageRoute isProtected={false}>
          <NoAccess />
        </PageRoute>
      }
    />
    <Route
      path="/signed-out"
      element={
        <PageRoute isProtected={false}>
          <SignedOut />
        </PageRoute>
      }
    />
  </>
);
